import { gql, TypedDocumentNode } from '@common/hooks';
import {
  HourBlockErrorsFragment,
  ReviewHourBlockFragment,
} from '@common/graphql/schema';
import { HistoryInfoFragment } from '@common/graphql';

import { HourEntry } from './hour-entry';

export const ReviewHourBlock: TypedDocumentNode<ReviewHourBlockFragment> = gql`
  fragment ReviewHourBlock on WorksTimekeepingHourBlock {
    id
    skippedLunchBreak
    totalSeconds
    notes
    state
    shiftDate
    classifiedTimes {
      holidaySeconds
      overtimeSeconds
    }
    canSoftDelete {
      value
    }
    workerTimesheet {
      id
      timesheet {
        id
      }
      canManagerUpsertHours {
        value
      }
    }
    unit {
      id
      name
      costCenter
    }
    facility {
      id
      name
      timeZone
    }
    inOut {
      ...HourEntry
    }
    lunchBreak {
      ...HourEntry
    }
    hourType {
      id
      name
    }
    billingRate
    history {
      ...HistoryInfoFragment
    }
  }
  ${HourEntry}
  ${HistoryInfoFragment}
`;

export const HourBlockErrors: TypedDocumentNode<HourBlockErrorsFragment> = gql`
  fragment HourBlockErrors on WorksTimekeepingHourBlockErrors {
    facility {
      message
    }
    unit {
      message
    }
    hourType {
      message
    }
    inOut {
      startedAt {
        message
      }
      endedAt {
        message
      }
    }
    lunchBreak {
      startedAt {
        message
      }
      endedAt {
        message
      }
    }
  }
`;
